export const ErrorCodes = {
  MINDMAP: {
    NODE_NOT_FOUND: 'MINDMAP_NODE_NOT_FOUND',
    INVALID_NODE_DATA: 'MINDMAP_INVALID_NODE_DATA',
    CONNECTION_ERROR: 'MINDMAP_CONNECTION_ERROR',
  },
  MARKDOWN: {
    PARSE_ERROR: 'MARKDOWN_PARSE_ERROR',
    CONVERSION_ERROR: 'MARKDOWN_CONVERSION_ERROR',
  },
  VIEWPORT: {
    INVALID_ZOOM: 'VIEWPORT_INVALID_ZOOM',
    INVALID_POSITION: 'VIEWPORT_INVALID_POSITION',
  }
};